import { BLOCKED_EXTENSIONS, WHATSAPP_ALLOWED_MIME, WHATSAPP_LIMITS } from './templateConstants';

function inferDocType(mime) {
  if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
  if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
  if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
  if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
  return null;
}

function bytesToMB(bytes) {
  return (bytes / (1024 * 1024)).toFixed(2);
}

export function validateHeaderFile(file) {
  if (!file) return { valid: false, message: 'No file selected' };

  if (file.size <= 0) {
    return {
      valid: false,
      message: 'File cannot be 0 MB (empty file). Please select a valid file.',
    };
  }

  const fileName = file.name?.toLowerCase() || '';
  const ext = fileName.includes('.') ? `.${fileName.split('.').pop()}` : '';

  if (BLOCKED_EXTENSIONS.has(ext)) {
    return { valid: false, message: `"${ext}" files are not allowed for security reasons.` };
  }

  const typeGroup = inferDocType(file.type);
  if (!typeGroup) {
    return { valid: false, message: `Unsupported file type (${file.type || ext}).` };
  }

  const limit = WHATSAPP_LIMITS[typeGroup];
  if (file.size > limit) {
    const typeLabel = typeGroup === 'file' ? 'document' : typeGroup;
    const limitMB = Math.round(limit / (1024 * 1024));
    return {
      valid: false,
      message: `File too large for ${typeLabel}. Max ${limitMB} MB. Your file is ${bytesToMB(file.size)} MB.`,
    };
  }

  return { valid: true };
}

export function validateExcelFile(file) {
  if (!file) return { valid: false, message: 'No file selected' };

  const ext = file.name?.toLowerCase().includes('.')
    ? `.${file.name.split('.').pop()}`
    : '';

  if (BLOCKED_EXTENSIONS.has(ext)) {
    return { valid: false, message: `Files with "${ext}" extension are not allowed.` };
  }

  const allowedTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ];

  if (!allowedTypes.includes(file.type)) {
    return { valid: false, message: 'Only Excel (.xlsx, .xls) files are allowed.' };
  }

  return { valid: true };
}

export function getHeaderAcceptValue(format) {
  if (format === 'IMAGE') return 'image/jpeg,image/png';
  if (format === 'VIDEO') return 'video/mp4,video/3gpp';
  if (format === 'DOCUMENT') return '.pdf,.doc,.docx,.xls,.xlsx,.txt';
  return '*/*';
}
